/* TRUBRND Shopify Theme — theme.js */
'use strict';

// ── Header scroll behavior ──────────────────────────────────
(function() {
  const header = document.querySelector('.tb-header');
  if (!header) return;
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 40);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// ── Mobile nav toggle ───────────────────────────────────────
(function() {
  const btn = document.querySelector('.tb-header__menu-btn');
  const nav = document.querySelector('.tb-mobile-nav');
  const close = document.querySelector('.tb-mobile-nav__close');
  if (!btn || !nav) return;
  btn.addEventListener('click', () => { nav.classList.add('open'); document.body.style.overflow = 'hidden'; });
  const closeNav = () => { nav.classList.remove('open'); document.body.style.overflow = ''; };
  if (close) close.addEventListener('click', closeNav);
  nav.querySelectorAll('a').forEach(a => a.addEventListener('click', closeNav));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeNav(); });
})();

// ── Cart count badge ────────────────────────────────────────
(function() {
  const badge = document.querySelector('.tb-header__cart-count');
  if (!badge) return;
  fetch('/cart.js').then(r => r.json()).then(cart => {
    badge.textContent = cart.item_count;
    badge.dataset.count = cart.item_count;
  }).catch(() => {});
})();

// ── Product gallery thumbnails ──────────────────────────────
(function() {
  const mainImg = document.getElementById('tb-product-img');
  if (!mainImg) return;
  document.querySelectorAll('.tb-product__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      mainImg.src = thumb.dataset.src;
      document.querySelectorAll('.tb-product__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
})();

// ── Quantity buttons ────────────────────────────────────────
(function() {
  document.querySelectorAll('.tb-product__qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const action = btn.dataset.action;
      const input = btn.closest('.tb-product__qty').querySelector('input[type="number"]');
      if (!input) return;
      let val = parseInt(input.value, 10) || 1;
      if (action === 'increase') val++;
      else if (action === 'decrease') val = Math.max(parseInt(input.min || '0', 10), val - 1);
      input.value = val;
    });
  });
})();

// ── Scroll reveal ───────────────────────────────────────────
(function() {
  if (!('IntersectionObserver' in window)) return;
  const style = document.createElement('style');
  style.textContent = `
    .reveal { opacity: 0; transform: translateY(24px); transition: opacity 0.55s cubic-bezier(0.23,1,0.32,1), transform 0.55s cubic-bezier(0.23,1,0.32,1); }
    .reveal.visible { opacity: 1; transform: none; }
    @media (prefers-reduced-motion: reduce) { .reveal { opacity: 1; transform: none; transition: none; } }
  `;
  document.head.appendChild(style);
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
  }, { threshold: 0.1 });
  document.querySelectorAll('.tb-creators__card, .tb-capabilities__cell, .tb-positioning__card, .tb-wyg__card, .tb-risk__badge, .tb-proof__card, .tb-pod__step, .tb-why__item, .tb-fulfill__item').forEach((el, i) => {
    el.classList.add('reveal');
    el.style.transitionDelay = `${(i % 4) * 80}ms`;
    io.observe(el);
  });
})();

// ── Ticker duplicate for seamless loop ─────────────────────
(function() {
  const track = document.querySelector('.tb-ticker__track');
  if (!track) return;
  const clone = track.cloneNode(true);
  track.parentElement.appendChild(clone);
})();
